import path from "path";
import type { QuoteMetadata } from "~types/types";
import logoBloomberg from "~assets/bloomberg-logo-amp.png";

const LOGO_WIDTH = 262;
const LOGO_HEIGHT = 60;
const LOGO_URL = path.join(logoBloomberg.src || "");
const SECTOR_BASE_URL = "https://www.bloomberg.com/markets/sectors";
const SECTOR_TO_PAGE: { [key: string]: string } = {
  communications: "/communication-services",
  "consumer discretionary": "/consumer-discretionary",
  "consumer staples": "/consumer-staples",
  energy: "/energy",
  financials: "/financials",
  "health care": "/health-care",
  industrials: "/industrials",
  materials: "/materials",
  technology: "/information-technology",
  utilities: "/utilities",
  default: "",
};

const PAGE_TYPE_MENTIONS_URL: { [key: string]: string } = {
  "quote-bazaar": "https://www.bloomberg.com/profile/company",
  "quote-companyProfile": "https://www.bloomberg.com/quote",
  default: "",
};

const getPublisherJson = () => {
  return {
    "@type": "Organization",
    name: "Bloomberg",
    url: "https://www.bloomberg.com",
    logo: {
      "@type": "ImageObject",
      url: LOGO_URL,
      width: LOGO_WIDTH,
      height: LOGO_HEIGHT,
    },
  };
};

const getThingJson = (name: string, url: string) => {
  return {
    "@context": "http://schema.org",
    "@type": "Thing",
    name,
    url,
  };
};

const getMentionsData = (
  id: string,
  type: string,
  displayName: string,
  bicsSector?: string
) => {
  const mentionsData: any[] = [];

  if (!id) {
    return mentionsData;
  }

  if (bicsSector) {
    const sector = bicsSector.toLowerCase();
    const sectorPage = SECTOR_TO_PAGE[sector] || SECTOR_TO_PAGE.default;
    const sectorUrl = `${SECTOR_BASE_URL}${sectorPage}`;
    const sectorMention = getThingJson(sector, sectorUrl);

    mentionsData.push(sectorMention);
  }

  const baseUrl =
    PAGE_TYPE_MENTIONS_URL[type] || PAGE_TYPE_MENTIONS_URL.default;
  const url = `${baseUrl}/${id}`;
  const quoteMention = getThingJson(displayName, url);

  mentionsData.push(quoteMention);

  return mentionsData;
};

export const getPageJsonLd = (metadata: QuoteMetadata) => {
  const {
    bicsSector,
    description,
    displayName,
    keywords,
    pageType,
    tickerId,
    title,
    url,
  } = metadata;

  return {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: title,
    description,
    keywords,
    mainEntityOfPage: url,
    mentions: getMentionsData(tickerId, pageType, displayName, bicsSector),
    publisher: getPublisherJson(),
    isAccessibleForFree: "False",
    hasPart: {
      "@type": "WebPageElement",
      isAccessibleForFree: "False",
      cssSelector: ".paywall",
    },
  };
};
